import {useEffect} from 'react'
import {useNavigate} from 'react-router'
import {initQueryParamNavigator} from './navigation'

export const QueryParamInitializer = () => {
    const navigate = useNavigate()

    useEffect(() => {
        initQueryParamNavigator(navigate)
    }, [navigate])

    return null
}
